import axios from "axios";
export default class HttpService
{
    url = "https://2079.doed.gov.np/api";
    //url = "http://127.0.0.1:8000/api";
    


    postData = async (item, added_url, tokenId = "") => {
        const token = await sessionStorage.getItem(tokenId);

        const requestOptions = this.postRequestOptions(token, item);

        // return fetch(this.url+"/"+added_url,requestOptions).then(
        //     response=>response.json()
        // )

        const response = await fetch(this.url + "/" + added_url, requestOptions);
        const data = await response.json();
        return data;
    }
    postFormData = async (item, added_url, tokenId = "") => {
        const token = await sessionStorage.getItem(tokenId);
        const requestOptions = this.postRequestOptionsFormData(token, item);

        return fetch(this.url + "/" + added_url, requestOptions).then(
            response => response.json()
        )
        //    const response = await fetch(this.url+"/"+added_url,requestOptions);
        //    const data  = response.json();
        //     return data;
    }


    getData = async (added_url, tokenId = "") => {
        const token = await sessionStorage.getItem(tokenId);

        const requestOptions = this.getRequestOptions(token);

        return fetch(this.url + "/" + added_url, requestOptions).then(
            response => response.json()
        )
        
        // const response = await fetch(this.url+"/"+added_url,requestOptions);
        // const data  = response.json();
        // return data;
    }
    getDataBySignal = async (added_url, tokenId = "", signal) => {
        const token = await sessionStorage.getItem(tokenId);

        const requestOptions = this.getRequestOptionsBySignal(token, signal);

        return fetch(this.url + "/" + added_url, requestOptions).then(
            response => response.json()
        )
        // const response = await fetch(this.url+"/"+added_url,requestOptions);
        // const data  = response.json();
        // return data;
    }


    getRequestOptions = (token) => {
        let requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
        }
        return requestOptions;
    }

    getRequestOptionsBySignal = (token, signal = { aborted: false, reason: undefined, onabort: null }) => {
        let requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            signal: signal
        }
        return requestOptions;
    }
    postRequestOptions = (token, item) => {
        let requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify(item)
        }
        return requestOptions;
    }
    postRequestOptionsFormData = (token, item) => {

        let requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': "*/*"
            },
            body: item
        }
        return requestOptions;
    }
    getDataAxios = async (added_url, tokenId = "") => {
        const token = await sessionStorage.getItem(tokenId);

        const requestOptions = this.getRequestOptionsAxios(token);

        const response = await axios.get(this.url + "/" + added_url, requestOptions).then(res => {

            return res.data;
        });

        return response;
    }
    getDataAxiosWithField = async (added_url, tokenId = "", field) => {
        const token = await sessionStorage.getItem(tokenId);

        const requestOptions = this.getRequestOptionsAxiosWithField(token, field);

        const response = await axios.get(this.url + "/" + added_url, requestOptions).then(res => {

            return res.data;
        });

        return response;
    }
    getDataAxiosBySignal = async (added_url, tokenId = "", signal) => {
        const token = await sessionStorage.getItem(tokenId);

        const requestOptions = this.getRequestOptionsAxiosBySignal(token, signal);

        const response = await axios.get(this.url + "/" + added_url, requestOptions).then(res => {

            return res.data;
        });

        return response;
    }

    getRequestOptionsAxios = (token) => {
        let requestOptions = {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            }
        }
        return requestOptions;
    }
    getRequestOptionsAxiosBySignal = (token, signal = { aborted: false, reason: undefined, onabort: null }) => {
        let requestOptions = {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },

            signal: signal
        }
        return requestOptions;
    }
    getRequestOptionsAxiosWithField = (token, field) => {
        let requestOptions = {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },

            body: field
        }
        return requestOptions;
    }
    getDataFile = async (added_url, tokenId = "", contentType, fileExtension) => {

        const token = await sessionStorage.getItem(tokenId);
        const requestOptions = this.getRequestOptionsFile(token);

        const response = await fetch(this.url + "/" + added_url, requestOptions);
        ;

        const reader = await response.body.getReader();
        var parentComponentInReadClientModal = this;
        let chunks = [];
        return reader.read().then(function processText({ done, value }) {

            if (done) {



                const blob = new Blob([chunks], { type: contentType });


                return URL.createObjectURL(blob);
            }
            
            const tempArray = new Uint8Array(chunks.length + value.length);
            tempArray.set(chunks);
            tempArray.set(value, chunks.length);
            chunks = tempArray

            return reader.read().then(processText)

        })
    }
    getRequestOptionsFile = (token) => {
        let requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': "*/*"
            }
        }
        return requestOptions;
    }

}